/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState, lazy, Suspense  } from "react";
import { Container, Col, Row, Card, Modal, Spinner } from "react-bootstrap";
import styles from "./index.module.css";
import parse from 'html-react-parser'
import { imagePath } from "../../helper";

const ApplyAndDownloadForm = lazy(() => import('../ApplyAndDownloadForm'));

const data = [
  {
    image: `${imagePath}PartnerBenefits/Just-like-icon.png`,
    imgheight: "45px",
    title: "Compete In Your Market",
    details: "You are the expert of your market. You are free to structure your own comp strategy to exceed 300 bps.",
  },
  {
    image: `${imagePath}PartnerBenefits/Exceptional-broker.png`,
    imgheight: "49px",
    title: "Exceptional Pricing",
    details: `<div>
        Check out Sun West’s Rate above.
      </div>`
  },
  {
    image: `${imagePath}PartnerBenefits/Fast-Approvals.png`,
    imgheight: "57px",
    title: "Fast Approvals",
    details: `Pre-Approval requests and loan submissions will be Pre-Approved and underwritten for approval on demand.`,
  },
  {
    image: `${imagePath}PartnerBenefits/Tru-approval.png`,
    imgheight: "49px",
    title: "TRU Approvals 12-24 hours!",
    details: `
      <div>
        We guarantee our 
        <a
          href="https://swmc.com/truapproval"
          target='_blank'
        > TRU Approvals
          </a> 
          so that your clients can make offers with no loan contingency.
      </div>`
  },
  {
    image: `${imagePath}PartnerBenefits/Faster-condition.png`,
    imgheight: "65px",
    title: "Faster Conditions",
    details: `In addition to fast approvals, you'll also benefit from our conditions reviewed on demand.`,
  },
  {
    image: `${imagePath}PartnerBenefits/Bilingual.png`,
    imgheight: "55px",
    title: "Bilingual LOA",
    details: `<div>
      You will have a designated Bilingual Loan Assistant at no charge to you!<br/>(Se habla Español.)
    </div>`,
  },
  {
    image: `${imagePath}PartnerBenefits/Morgan-logo.png`,
    imgheight: "50px",
    title: `
      <a href="https://www.askangel.ai" target="_blank" style="color:inherit;">
      AngelAi</a>`,
    details: `24/7 Support from <a href="https://www.askangel.ai" target="_blank">
    AngelAi</a>, Sun West's proprietary Artificial Intelligence. Your personal loan expert on anything and EVERYTHING you could need!`,
  },
  {
    image: `${imagePath}PartnerBenefits/Admin.png`,
    imgheight: "55px",
    title: "Admin Assistance",
    details: `Designated assistance M-F 8am-8pm to handle everything including emails, appointments & marketing coordination.`,
  },
  {
    image: `${imagePath}PartnerBenefits/Technology.png`,
    imgheight: "45px",
    title: "Technology",
    details: `You'll benefit from our fully integrated, proprietary tech stack including LOS/POS/CRM/Pricing Engine & 
      <a href="https://www.askangel.ai" target="_blank">
      AngelAi</a>!`,
  },
  {
    image: `${imagePath}PartnerBenefits/Clients-for-life.png`,
    imgheight: "46px",
    title: "Customers for Life",
    details: `We service the majority of our loans. Your name will be front & center on every communication, including statements.`,
  },
  {
    image: `${imagePath}PartnerBenefits/Commissions-in-24-Hours.png`,
    imgheight: "45px",
    title: "Commissions in 24 Hours",
    details: `Loan originator commissions are advanced within 24 hours of loan disbursement.`
  },
  {
    image: `${imagePath}PartnerBenefits/Special-offer-icon.png`,
    imgheight: "49px",
    title: "Special Offer",
    details: `This offer is not available in all markets.`
  }  
];
const PartnerBenefits = ({ links }) => {
  const [downloadModal, setDownloadModal] = useState(false);
  const closeModal = () => setDownloadModal(false);
  const showContactUsForm = () => {
    setDownloadModal(true);
  } 
  return (
    <Container fluid className={styles.partner_benefits_info_section}>
      <h2 className={styles.partner_benefits_title}>
        <div className={styles.partner_benefits_title_part1}>Partnership</div>
        <div className={styles.partner_benefits_title_part2}>Benefits</div>
      </h2>
      <Container fluid className={styles.cards_container}>
        <Row className={styles.cards_container_row}>
          {data.map((cardItem, i) => (
            <Col lg={6} md={5} sm={12} key={i} className={styles.cards_container_col + ' '+ (!cardItem.title ? styles._blankCol : '')}>
              <Card className={styles.cards_class}>
                <Col
                  lg={2}
                  md={3}
                  sm={2}
                  xs={4}
                >
                  <Card.Img
                    variant="left"
                    className={styles.img_container}
                    src={cardItem.image}
                    width="50px"
                    height={cardItem.imgheight}
                  />
                </Col>
                {/* Incorrect column numbers present here help for responisveness */}
                <Col
                  lg={10}
                  md={10}
                  sm={9}
                  xs={9}
                >
                  <Row
                    style={{
                      color: '#083f88',
                      paddingLeft: "0.5rem",
                    }}
                  >
                    <Card.Title className={styles.title}>{parse(cardItem.title)}</Card.Title>
                  </Row>
                  <Row
                    style={{
                      paddingLeft: "0.5rem",
                    }}
                  >
                    <Card.Subtitle className={styles.subTitle}>{parse(cardItem.details)}</Card.Subtitle>
                  </Row>
                </Col>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <Modal
        id="downloadModal"
        show={downloadModal}
        onHide={closeModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-0">
          <Suspense fallback={<div className="text-center"><Spinner /></div>}>
            <ApplyAndDownloadForm />
          </Suspense>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default PartnerBenefits;
